import { useId, useRef } from 'react'
import { useVerifyEmailAnimation } from './useVerifyEmailAnimation'

export const VerifyEmailIllustration = () => {
  const id = useId()
  const paperShadingMaskId = `${id}-paper-shading-mask`
  const highlightMaskId = `${id}-highlight-mask`
  const paperRef = useRef<SVGGElement>(null)
  const checkmarkRef = useRef<SVGGElement>(null)

  useVerifyEmailAnimation({ paperRef, checkmarkRef })

  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <g id="verify-email">
        <rect width="80" height="80" fill="white" />
        <g id="shadow" style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M72.8418 71.8578C72.8418 73.4381 57.1613 74.7156 37.8189 74.7156C18.4766 74.7156 1 73.4381 1 71.8578C1 70.2774 18.4766 69 37.8189 69C57.1613 69 72.8418 70.2803 72.8418 71.8578Z"
            fill="#90B3A8"
          />
        </g>
        <g id="envelope">
          <path
            id="envelope-bottom"
            d="M8.00098 35.1825L38.3381 10.1478C40.2636 8.5588 43.0643 8.62679 44.9105 10.3073L72.237 35.1825L72.237 71.6149H8.00098L8.00098 35.1825Z"
            fill="#C5ECE0"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <g id="paper-shading">
            <mask
              id={paperShadingMaskId}
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="7"
              y="8"
              width="66"
              height="64"
            >
              <path
                d="M8 35.1825L38.3371 10.1478C40.2626 8.5588 43.0633 8.62679 44.9095 10.3073L72.2361 35.1825L72.2361 71.6149H8L8 35.1825Z"
                fill="#F2D891"
                stroke="#1D1D1D"
                strokeWidth="0.3"
              />
            </mask>
            {/* mix-blend-mode must live on this masked element itself, not a
                child — a mask on an ancestor isolates descendants' blend
                modes so they only blend with each other, not the artwork
                behind them. */}
            <g
              mask={`url(#${paperShadingMaskId})`}
              opacity="0.5"
              style={{ mixBlendMode: 'multiply' }}
            >
              <path
                d="M12.0154 11C11.9819 12.9541 12.0154 15.0034 12.0154 17.1755V17.4482C12.0154 20.8952 12.0154 24.6096 12.0154 28.3477C12.0154 30.2452 11.9807 32.215 12.0154 34.1292C12.4536 58.3159 17.0857 64.4304 19.6893 72H71C68.4722 59.5632 62.0276 48.3475 62.0276 22.6029C61.9892 21.1047 62.0276 19.5786 62.0276 18.0347C62.0276 15.5157 62.0462 13.1954 62.0393 11H12.0154Z"
                fill="#C5ECE0"
              />
            </g>
          </g>
          <g ref={paperRef} id="paper-sheet">
            <path
              d="M64.4227 12.999C64.4297 15.0819 64.411 17.2878 64.411 19.6758C64.411 21.1465 64.3726 22.5875 64.411 24.0068V24.0107C64.411 41.0161 67.5461 51.3132 70.3104 60H17.2596C17.1426 59.6344 17.0254 59.2593 16.911 58.873C15.3609 53.6398 14.0854 46.4373 13.8651 34.9512C13.8302 33.133 13.8651 31.2584 13.8651 29.4619V18.8604C13.8651 16.8029 13.8315 14.853 13.8651 12.9971L13.868 12.8496H64.4217L64.4227 12.999Z"
              fill="white"
            />
            <path
              d="M64.4227 12.999L64.5727 12.9985V12.998L64.4227 12.999ZM64.411 19.6758L64.561 19.6758V19.6758H64.411ZM64.411 24.0068H64.5611L64.561 24.0028L64.411 24.0068ZM64.411 24.0107H64.261V24.0107H64.411ZM70.3104 60V60.15H70.5156L70.4534 59.9545L70.3104 60ZM17.2596 60L17.1168 60.0457L17.1502 60.15H17.2596V60ZM16.911 58.873L16.7672 58.9156V58.9156L16.911 58.873ZM13.8651 34.9512L13.7151 34.954H13.7151L13.8651 34.9512ZM13.8651 12.9971L13.7151 12.9941L13.7151 12.9944L13.8651 12.9971ZM13.868 12.8496V12.6996H13.721L13.7181 12.8466L13.868 12.8496ZM64.4217 12.8496L64.5717 12.8486L64.5708 12.6996H64.4217V12.8496ZM64.4227 12.999L64.2727 12.9995C64.2797 15.0828 64.261 17.2854 64.261 19.6758H64.411H64.561C64.561 17.2902 64.5797 15.0811 64.5727 12.9985L64.4227 12.999ZM64.411 19.6758L64.261 19.6758C64.261 21.1408 64.2225 22.5892 64.2611 24.0109L64.411 24.0068L64.561 24.0028C64.5226 22.5859 64.561 21.1522 64.561 19.6758L64.411 19.6758ZM64.411 24.0068H64.261V24.0107H64.411H64.561V24.0068H64.411ZM64.411 24.0107H64.261C64.261 41.0384 67.4011 51.3524 70.1675 60.0455L70.3104 60L70.4534 59.9545C67.691 51.274 64.561 40.9938 64.561 24.0107H64.411ZM70.3104 60V59.85H17.2596V60V60.15H70.3104V60ZM17.2596 60L17.4025 59.9543C17.2857 59.5893 17.1688 59.2153 17.0548 58.8304L16.911 58.873L16.7672 58.9156C16.882 59.3033 16.9995 59.6794 17.1168 60.0457L17.2596 60ZM16.911 58.873L17.0548 58.8304C15.5094 53.613 14.2352 46.4243 14.0151 34.9483L13.8651 34.9512L13.7151 34.954C13.9357 46.4503 15.2124 53.6667 16.7672 58.9156L16.911 58.873ZM13.8651 34.9512L14.0151 34.9483C13.9802 33.1318 14.0151 31.2625 14.0151 29.4619H13.8651H13.7151C13.7151 31.2544 13.6802 33.1342 13.7151 34.954L13.8651 34.9512ZM13.8651 29.4619H14.0151V18.8604H13.8651H13.7151V29.4619H13.8651ZM13.8651 18.8604H14.0151C14.0151 16.7992 13.9815 14.8541 14.0151 12.9998L13.8651 12.9971L13.7151 12.9944C13.6815 14.8519 13.7151 16.8066 13.7151 18.8604H13.8651ZM13.8651 12.9971L14.0151 13L14.018 12.8526L13.868 12.8496L13.7181 12.8466L13.7151 12.9941L13.8651 12.9971ZM13.868 12.8496V12.9996H64.4217V12.8496V12.6996H13.868V12.8496ZM64.4217 12.8496L64.2718 12.8506L64.2727 13L64.4227 12.999L64.5727 12.998L64.5717 12.8486L64.4217 12.8496Z"
              fill="black"
            />
          </g>
          <g id="envelope-top">
            <path
              d="M43.1299 54.4344L8.00079 71.6152L8.00079 35.4824L43.1299 54.4344Z"
              fill="#F5FCFA"
              stroke="#1D1D1D"
              strokeWidth="0.3"
            />
            <path
              d="M37 54.4349L72.1291 71.6157L72.1291 35.4829L37 54.4349Z"
              fill="#F5FCFA"
              stroke="#1D1D1D"
              strokeWidth="0.3"
            />
            <path
              d="M38.6259 49.9361C40.4426 48.6373 42.8989 48.6951 44.6523 50.078L72.2361 71.8322H8L38.6259 49.9361Z"
              fill="#F5FCFA"
              stroke="#1D1D1D"
              strokeWidth="0.3"
              strokeLinejoin="bevel"
            />
          </g>
          <g ref={checkmarkRef} id="checkmark">
            <circle
              cx="40.2309"
              cy="31.231"
              r="12.0761"
              transform="rotate(-4.92668 40.2309 31.231)"
              fill="#A5D6BF"
              stroke="black"
              strokeWidth="0.3"
            />
            <circle
              cx="40.2313"
              cy="31.2316"
              r="9.64989"
              transform="rotate(-4.92668 40.2313 31.2316)"
              fill="#F5FCFA"
              stroke="black"
              strokeWidth="0.3"
            />
            <path
              d="M36.6507 34.7896C36.068 34.1367 35.4806 33.5507 34.8029 32.9362C34.2805 32.4625 34.2217 31.6549 34.6909 31.1265C35.1387 30.6223 35.9075 30.5545 36.4188 30.9921C37.0564 31.5378 37.5967 32.0586 38.2214 32.8064C38.57 33.2235 39.2283 33.2027 39.5334 32.7514C41.0339 30.5318 42.1906 29.0482 43.8904 27.0979C44.3781 26.5383 45.2472 26.5453 45.7303 27.1069C46.1274 27.5685 46.1232 28.2528 45.7271 28.7168C43.9263 30.8264 42.6453 32.5084 41.2634 34.5631C40.2018 36.1416 37.9147 36.2059 36.6507 34.7896Z"
              fill="#41826E"
              stroke="#1D1D1D"
              strokeWidth="0.3"
              strokeLinecap="round"
            />
          </g>
        </g>
        <g id="highlight">
          <mask
            id={highlightMaskId}
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="8"
            y="35"
            width="65"
            height="37"
          >
            <path
              d="M72.4287 71.4434L72.4785 71.4834L72.3857 71.751H8.14941L8.09375 71.5771L8 71.624V35L8.22168 35.1191L37.1152 50.707L38.6885 49.583C40.5593 48.2455 43.0887 48.3044 44.8945 49.7285L44.9883 49.8027L72.207 35.1191L72.4287 35V71.4434Z"
              fill="#FFF9E9"
            />
          </mask>
          {/* Each stripe gets its own mask + mix-blend-mode on the same
              element (see paper-shading above) — sharing one masked wrapper
              over both would flatten them into a single layer via normal
              compositing before that layer multiplies against the artwork,
              so only one stripe would visibly blend. */}
          <g
            mask={`url(#${highlightMaskId})`}
            style={{ mixBlendMode: 'multiply' }}
          >
            <rect
              width="37.6149"
              height="78.6758"
              transform="matrix(0.964616 -0.26366 0.52821 0.849114 7.15918 27.9175)"
              fill="#F5FCFA"
            />
          </g>
          <g
            mask={`url(#${highlightMaskId})`}
            style={{ mixBlendMode: 'multiply' }}
          >
            <rect
              width="37.6149"
              height="75.2466"
              transform="matrix(0.964616 -0.26366 0.52821 0.849114 1 33.1069)"
              fill="#F5FCFA"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
